import { ProgramFilterStatusBackEndKey } from 'utils/enums';
import { isNull } from 'lodash';

// Simple helpers (replace with dayjs if you prefer)
const toDate = iso => {
  try {
    if(!isNull(iso)){

    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;

    } else {
      return '';
    }
    
  } catch {
    return null;
  }
};

const toCurrency = n =>
  typeof n === 'number'
    ? n.toLocaleString('el-GR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
      })
    : undefined;

// Code ➜ label lookups
const SIZE_MAP = {
  MICRO: 'Πολύ Μικρή',
  SMALL: 'Μικρή',
  MEDIUM: 'Μεσαία',
  LARGE: 'Μεγάλη',
};

const EXPENSE_MAP = {
  VEH_USE: 'Χρήση οχημάτων',
  LAND_USE: 'Χρήση γης/ακινήτων',
  CONS: 'Καταναλωτικά/Υλικά',
  INT_PUR: 'Αγορές άυλων/δικαιωμάτων',
};

// Build "50% – 70% (10.000€ – 150.000€)" if amounts exist
const buildFundingPercentage = (minPct, maxPct) => {
  if (minPct == null && maxPct == null) return undefined;
  const pct =
    minPct != null && maxPct != null
      ? `${minPct} – ${maxPct}%`
      : minPct != null
      ? `${minPct}%`
      : `${maxPct}%`;

  return `${pct}`;
};

const buildFundingAmount = (minAmt, maxAmt) => {
  const amt =
    minAmt != null && maxAmt != null
      ? `${toCurrency(minAmt)} – ${toCurrency(maxAmt)}`
      : minAmt != null
      ? toCurrency(minAmt)  
      : maxAmt != null
      ? toCurrency(maxAmt)  
      : '';

  return amt;
};

// ONE program item ➜ card props
export const mapProgram = api => ({
  id: api.id,
  source: api.fundingSourceCode, // "ESPA"
  title: api.title,
  description: api.description,
  closesInDays: api.remainingDays, // number
  sizes: (api.companySizeCodes || []).map(c => SIZE_MAP[c] || c),
  categories: (api.expenseClassCodeList || []).map(c => EXPENSE_MAP[c] || c),
  fundingPercentage: buildFundingPercentage(
    api.minFundingPercentage,
    api.maxFundingPercentage
  ),
  fundingAmount: buildFundingAmount(api.minFundingAmount, api.maxFundingAmount),
  deadline: toDate(api.endOfSubmission),
});

// Whole payload ➜ sections array you can render in order
export const mapPayloadToSections = payload => [
  {
    key: ProgramFilterStatusBackEndKey.ClosingSoon,
    title: 'Προγράμματα που κλείνουν σύντομα',
    programs: (payload[ProgramFilterStatusBackEndKey.ClosingSoon] || []).map(
      mapProgram
    ),
  },
  {
    key: ProgramFilterStatusBackEndKey.Open,
    title: 'Ανοιχτά προγράμματα',
    programs: (payload[ProgramFilterStatusBackEndKey.Open] || []).map(
      mapProgram
    ),
  },
  // {
  //   key: ProgramFilterStatusBackEndKey.Insights,
  //   title: 'GT Insights',
  //   programs: (payload[ProgramFilterStatusBackEndKey.Insights] || []).map(
  //     mapProgram
  //   ),
  // },
  {
    key: ProgramFilterStatusBackEndKey.Expired,
    title: 'Ληγμένα προγράμματα',
    programs: (payload[ProgramFilterStatusBackEndKey.Expired] || []).map(
      mapProgram
    ),
  },
];

// Whole payload ➜ sections array you can render in order
export const mapPayloadToSectionsFundingPrograms = payload => [
  {
    key: 'fundingPrograms',
    title: 'Προτεινόμενος Συνδυασμός',
    programs: (payload.fundingPrograms|| []).map(
      mapProgram
    ),
  },
];

/**
 * @description It actually maps with the local state keys of the reducer of useFundingFilters for categories.
 * - fundingInsights
 * - expired
 * - closeToExpire
 * - openProgram
 */
export const sectionTitleToLocalStateKeyMap = {
  'Προγράμματα που κλείνουν σύντομα': 'closeToExpire',
  'Ανοιχτά προγράμματα': 'openProgram',
  'GT Insights': 'fundingInsights',
  'Ληγμένα προγράμματα': 'expired',
};
